import {  get } from "../../service/api";

const GetCompanyInfo = async (register) => {
    try {
        const response = await get(`/merchant/companyInfo?register=${register}`);
        return response.data;
    } catch (error) {
        console.error('Error GetCompanyInfo:', error);
        throw error;
    }
};

export default GetCompanyInfo;